import { render, staticRenderFns } from "./FormRightLocale.vue?vue&type=template&id=832244a4&scoped=true&"
import script from "./FormRightLocale.vue?vue&type=script&lang=js&"
export * from "./FormRightLocale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "832244a4",
  null
  
)

export default component.exports